export default __webpack_public_path__ + "static/media/b8.7485f2e6.jpg";